import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import { useSelector } from 'react-redux';
import { RootState } from '@/store/index';
import '@/pages/timeline/sections/timeline/timelineSections/certificate/style.css'
import PlainWhiteTick from '@/assets/icons/plainWhiteTick.png';

import moment from 'moment';

export default function CertificateDispatched(props: any) {
    const { timeline, common } = useLocalTranslation();
    const timelineDetails = useSelector((state: RootState) => state.timelineReducer.timeline);
    return (
        <div className='commonMainCon'>
            <p className='commonp1 mb-[8px]'>
                {timeline.certificateSection.certificateDispatched.h1}
                <strong>{' '}{moment(timelineDetails.certificateDispatchedAt).format('DD MMM, YYYY')}</strong>
            </p>
            <p className='text-red-500 font-medium mb-[5px]'>{props.certificateErr}</p>
            <p className='commonp1 mb-[15px] text-[#616060] text-[14px]'>{timeline.certificateSection.certificateDispatched.p1}</p>
            <button
                disabled={props.isCertificateBtnLoading}
                style={{
                    cursor: props.isCertificateBtnLoading ? 'not-allowed' : 'pointer',
                    backgroundColor: props.isCertificateBtnLoading ? '#b9b9ba' : '#0073E6'
                }}
                onClick={() => props.handleConfirmCertificateDelivered()}
                className='commonb1 commonb1_bg_blue cursor-pointer flex justify-center items-center'>
                {!props.isCertificateBtnLoading &&
                    <img
                        className='w-[15px] mr-[5px]'
                        src={PlainWhiteTick} alt='PlainWhiteTick' />
                }
                {props.isCertificateBtnLoading ? common.statusText.loading : timeline.certificateSection.certificateDispatched.b1}
            </button>
        </div>
    );
};


